import * as React from 'react';
import MainContentSection from './MainContentSection';
import HeaderRegion from './HeaderRegion';
import FooterRegion from './FooterRegion';
import '../styles/App.css';

const bananaLogo = require('../images/BananaLogo.png');
const monkeyLogo = require('../images/MonkeyLogo.png');

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <div className="OuterMainContainer">
          <div className="InnerMainContainer">
            <div className="PageTitleRegion"><h1 className="PageTitleText">Popular Monkey</h1></div>
            <div className="YellowBorderOutside">
              <div className="YellowBorderInside">
                <HeaderRegion />
                <MainContentSection />
                <FooterRegion />
              </div>
            </div>
            <div className="CopyrightRegion">
              <span className="CopyrightText">Copyright &copy; 2013-2017 Popular Monkey - All Rights Reserved.</span>
            </div>
            <div className="MonkeyLogoDiv"><img src={monkeyLogo} className="MonkeyLogo" alt="Monkey" /></div>
            <div className="BananaLogoDiv"><img src={bananaLogo} className="BananaLogo" alt="Bananas" /></div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/App.tsx